<style>


</style>

<template>
  <div>

    <h2>Pieces to download</h2>
    <div v-for="q in questionsWithFile">
      <div v-for="f in q.files(values)" class="light-frame">


        <div style="display: flex; align-items: center; justify-content: space-between">
          <div class="md-body-2" v-html="f.label.en"></div>

          <div @click="onClickUpload($event)">
            <input type="file" accept="application/pdf,image/*" multiple
                  style="display: none"
                  @click="fileInputClick($event, f.id)"
                  @change="fileInputChange($event, f.id)"
            >

            <md-button class="md-icon-button md-raised md-primary md-mini" style="margin: 16px 0px 16px 16px">
              <md-icon>file_upload</md-icon>
            </md-button>
          </div>
        </div>

        <div v-if="values._files && values._files[f.id] && values._files[f.id]">

          <div v-for="file in values._files[f.id]" style="display: flex; align-items: center">

            <md-button class="md-icon-button" @click="removeFile(f.id, file.hashname)">
              <md-icon>delete</md-icon>
            </md-button>
            <md-button class="md-accent" @click="onClickShowFile(file.hashname)" >{{file.filename}}</md-button>

          </div>
        </div>




      </div>
    </div>


    <div v-for="(percent, name) in uploadingFiles">
      Download{{name}} : {{percent}}%
    </div>

     <div class="centered-child" style="margin-top: 48px">
        <md-button class="md-raised md-primary large-button"
          @click="onClickContinue()"
          >Continue</md-button>
      </div>
  </div>
</template>

<script>
import ServiceAccess from '../service/ServiceAccess'

export default {

  data: function () {
    return {
      values: {},

      questions: {},
      questionsWithFile: [],

      uploadingFiles: {}

    }
  },

  created: function () {
    global.navigationBarBus.$on('navigation-back', this.prevScreen)
    global.navigationBarBus.$emit('navigation-display-back', true)
    global.navigationBarBus.$emit('display-save', false)

    let promises = [
      ServiceAccess.instance.loadValues(this.$route.params.sessionId),
      ServiceAccess.instance.loadQuestions()
    ]
    Promise.all(promises).then(responses => {
      let [values, questions] = responses

      this.questions = questions

      if (!('_files' in values)) {
        values._files = {}
      }

      for (let key in values) {
        if (key.startsWith('_')) { continue }
        let question = this.questions[key]
        if (question != null && question.hasFile()) {
          this.questionsWithFile.push(question)
        }
      }

      this.values = values

    })
  },

  destroyed: function () {
    global.navigationBarBus.$off('navigation-back', this.prevScreen)
  },


  // -----------------------------------------------------------------------

  methods: {
    prevScreen: function () {
      this.$router.push('/f/' + this.$route.params.sessionId)
    },

    onClickUpload: function (event) {
      event.currentTarget.querySelector('input').click()
    },

    onClickShowFile: function (hashname) {
      window.open(this.fileRef(hashname), '_blank')
    },

    fileInputClick: function (event, fid) {
    },
    fileInputChange: function (event, fid) {
      let files = event.target.files
      if (!(files instanceof Array)) {
        if ('length' in files && 'item' in files) { // safari
          let array = []
          for (let i = 0; i < files.length; i++) {
            array.push(files.item(i))
          }
          files = array
        } else {
          window.alert('Unknown file type: ' + (typeof files))
          console.error('Unknown file type: ' + (typeof files))
        }
      }
      this.fileUpload(files, fid)
    },

    uploadProgress: function (file, event) {
      let forceUpdate = !(file.name in this.uploadingFiles)
      this.uploadingFiles[file.name] = Math.round((event.loaded / event.total) * 100)
      if (forceUpdate) { this.$forceUpdate() }
    },

    fileUpload: function (files, fid) {

      if (!(fid in this.values._files)) {
        this.values._files[fid] = []
      }

      for (let file of files) {
        ServiceAccess.instance.storeFile(this.$route.params.sessionId, file, this.uploadProgress).then((fileResponse) => {
          delete this.uploadingFiles[file.name]
          this.removeFile(fid, fileResponse.hashname)
          this.values._files[fid].push(fileResponse)
          ServiceAccess.instance.storeValues(this.$route.params.sessionId, this.values)
          console.log('File uploaded: ' + JSON.stringify(fileResponse))
          this.$forceUpdate()
        }, (err) => {
          delete this.uploadingFiles[file.name]
          this.$forceUpdate()
          console.error('File error: ', err)
        })

      }

    },

    fileRef: function (filename) {
      return ServiceAccess.instance.serviceURL + '/file/' + this.$route.params.sessionId + '/' + filename
    },

    removeFile: function (fid, hashname) {
      if (this.values._files[fid]) {
        this.values._files[fid] = this.values._files[fid].filter(f => f.hashname !== hashname)
      }
      ServiceAccess.instance.storeValues(this.$route.params.sessionId, this.values)
      this.$forceUpdate()
    },

    onClickContinue: function () {
      this.$router.replace('/f/' + this.$route.params.sessionId + '/')

    }
  }
}

</script>



// WEBPACK FOOTER //
// Summary.vue?ff46d9be